import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
} from '@angular/core';
import { WalletService } from '../interfaces/wallet-service.interface';

export const DataAccessWalletService = new InjectionToken<WalletService>(
  'WalletService',
);

export interface WalletServiceUseClass extends ClassSansProvider {
  useClass: Type<WalletService>;
}

export interface WalletServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => WalletService;
}

export type WalletServiceProvider =
  | WalletServiceUseFactory
  | WalletServiceUseClass;

export function provideDataAccessWalletService(config: WalletServiceProvider) {
  return {
    provide: DataAccessWalletService,
    ...config,
  };
}
